import { ADD_ACTION, EDIT_ACTION, VIEW_ACTION } from "constants/actions";
import { NCR_REGION_ID } from "utility/constants";

export const validateTVISettingsForm = ({
  form,
  selectedCourses,
  coursesOptions,
  action,
}) => {
  if (!form.municipalityId && form.regionId?.value !== NCR_REGION_ID) {
    return "Municipality cannot be empty";
  }

  if (selectedCourses.length === 0) {
    return "Please select a course";
  }

  const allHaveCapacity = selectedCourses.every(
    (course) => course.capacity > 0
  );

  if (!allHaveCapacity) {
    return "All selected courses must have a capacity greater than 0";
  }

  const allWithinAvailableSlots = selectedCourses.every((course) => {
    const courseDetails = coursesOptions.find(
      (item) => item.courseId === course.courseId
    );

    const maxCapacity =
      action === ADD_ACTION
        ? courseDetails.availableSlots
        : course.oldCapacityValue + courseDetails.availableSlots;

    return courseDetails && course.capacity <= maxCapacity;
  });

  if (!allWithinAvailableSlots) {
    return "All selected courses must have a capacity that does not exceed available slots";
  }

  const allEndorsedCoursesValid = selectedCourses.every((course) => {
    return (
      !course.hasEndorsements || course.capacity >= course.oldCapacityValue
    );
  });

  if (!allEndorsedCoursesValid) {
    return "Endorsed courses cannot have a capacity less than their previous value";
  }

  return true;
};

export const getHeaderText = (action) => {
  let headerText = "TVI Details";

  if (action === EDIT_ACTION) {
    return "Edit TVI";
  }

  if (action !== VIEW_ACTION) {
    headerText = "Add New TVI";
  }

  return headerText;
};

export const getTooltipText = (hasEndorsementsConflict, exceedsCapacity) => {
  if (hasEndorsementsConflict) {
    return "Entered ABSCAP cannot be less than current value.";
  }

  if (exceedsCapacity) {
    return "Entered ABSCAP cannot exceed available slots.";
  }

  return "";
};
